import { ScrollCard, SectionLabel, cn } from '@wundo/ui';
import type { RoleplayScenario } from '@wundo/shared/roleplay.ts';
import { PracticeObjectiveList } from './PracticeObjectiveList.tsx';
import { m } from '@/paraglide/messages.js';

export interface PracticeSessionBriefPanesProps {
  scenario: RoleplayScenario;
  className?: string;
}

/**
 * The brief before the start: situation and objectives side by side, equally
 * tall, each scrolling under its own title so a long situation never pushes the
 * start off the screen. Below the agenda breakpoint they stack and scroll as one.
 */
export function PracticeSessionBriefPanes({
  scenario,
  className,
}: PracticeSessionBriefPanesProps) {
  return (
    <div
      className={cn(
        'flex min-h-0 flex-col gap-4.5 overflow-y-auto agenda:flex-row agenda:overflow-visible',
        className,
      )}
    >
      <ScrollCard
        className='shrink-0 agenda:flex-3'
        title={<SectionLabel as='h2'>{m.practice_situation()}</SectionLabel>}
      >
        <p className='text-md text-ink-body'>{scenario.situation}</p>
      </ScrollCard>

      <ScrollCard
        className='shrink-0 agenda:flex-2'
        title={<SectionLabel as='h2'>{m.practice_objectives()}</SectionLabel>}
      >
        <PracticeObjectiveList objectives={scenario.learning_objectives} />
      </ScrollCard>
    </div>
  );
}
